import { ScreeningTabEnum } from "@abbvie-epi/common/enums";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";

@Component({
    selector: "app-introduction",
    templateUrl: "./introduction.component.html",
    styleUrls: ["./introduction.component.scss"]
})
export class IntroductionComponent implements OnInit {
    public dropdownIsActive: boolean = false;
    public isModalOpen: boolean = false;

    public tableIsOpen: boolean = false;

    public ScreeningTabEnum = ScreeningTabEnum;

    @Output() activeTab: EventEmitter<ScreeningTabEnum> = new EventEmitter<ScreeningTabEnum>();

    constructor(private analyticsHelper: AnalyticsHelperService) {}

    ngOnInit(): void {}

    public toggleDropdown() {
        if (!this.dropdownIsActive) {
            this.analyticsHelper.trackInteraction("screening-tool-landing-introduction-variables-accordion-expand");
        } else {
            this.analyticsHelper.trackInteraction("screening-tool-landing-introduction-variables-accordion-close");
        }

        this.dropdownIsActive = !this.dropdownIsActive;
    }

    public hideModal() {
        this.isModalOpen = false;

        this.track("screening-tool-landing-introduction-user-guide-close");
    }

    public openModal(trackingId?: string) {
        this.isModalOpen = true;

        if (trackingId) {
            this.analyticsHelper.trackInteraction(trackingId);
        }
    }

    public openTable() {
        this.tableIsOpen = true;
        document.body.style.overflow = "hidden";

        this.analyticsHelper.trackInteraction("screening-tool-landing-introduction-variables-list-modal-open");
    }

    public closeTable() {
        this.tableIsOpen = false;
        document.body.style.overflow = "scroll";
        this.analyticsHelper.trackInteraction("screening-tool-landing-introduction-variables-list-modal-close");
    }

    public track(id: string): void {
        this.analyticsHelper.trackInteraction(id);
    }
}
